// extracted by mini-css-extract-plugin
export default {"container":"coupon_container__gGM99"};